import { Pipe, PipeTransform } from '@angular/core';
import { DatePickerDate } from '../../core/types';
import { CalendarUtils } from '../../core/utils/CalendarUtils';
import { ICinemaWeek } from '../../core/interfaces/ICinemaWeek';

@Pipe({
  name: 'kw',
  standalone: true
})
export class KwPipe implements PipeTransform {

  public transform(date: DatePickerDate): ICinemaWeek {
    return CalendarUtils.getCinemaWeek(date);
  }
}
